import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SimpleModalService } from 'ngx-simple-modal';
import { Constants } from '../common/constants';
import { GUI } from '../common/gui';
import { HttpUtils } from '../common/http-utils';
import { LoaderService } from '../common/loader-service';
import { LocalStorage } from '../common/local-storage';
import { Route } from '../common/route';
import { Toast } from '../common/toast';
import { Utils } from '../common/utils';
import { FileViewModalComponent } from '../file-view-modal/file-view-modal.component';
import { PaymentReceiptModalComponent } from '../payment-receipt-modal/payment-receipt-modal.component';

@Component({
  selector: 'app-application-view-v1',
  templateUrl: './application-view-v1.component.html',
  styleUrls: ['./application-view-v1.component.css']
})
export class ApplicationViewV1Component {

  private encrypedApplicationId : string = this.constants.BLANK;

  private encrypedReferenceId : string = this.constants.BLANK;

  private encryptedIsSearchFromHome : string = this.constants.BLANK;

  isSearchFromHome : number = this.constants.FALSE;

  private loggedUserId : string = this.constants.BLANK;

  generalDetails : any = {};

  feeDetails : any = {};

  bioDetails : any = {};

  travelDetails : any = {};

  contactDetails : any = {};

  applicationDocuments : any = {};

  isPaid : boolean = false;

  paymentDetails : any = {};

  barCodeValue : string = this.constants.BLANK;

  isShowPaymentDetails : boolean = false;

  applicationDocumentsArray : any = [];

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private route: Route, private httpUtils: HttpUtils, private toast: Toast, public utils: Utils, public constants: Constants, 
              private loaderService: LoaderService, private simpleModalService: SimpleModalService, private localStorage: LocalStorage, private gui: GUI){ 
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.encrypedApplicationId = params['applicationId'];
      this.encrypedReferenceId = params['referenceId'];
      this.encryptedIsSearchFromHome = params["isSearchFromHome"];
    });

    if(this.utils.isEmpty(this.encryptedIsSearchFromHome) === false){
      this.isSearchFromHome = Number(this.utils.decryptString(this.encryptedIsSearchFromHome));
    }

    this.loggedUserId = this.localStorage.getLoggedUserId();
    this.storeApplicationData();
  }

  private storeApplicationData(){
    this.loaderService.startLoader();
    const applicationIdV1 = this.utils.decryptString(this.encrypedApplicationId);
    const referenceIdV1 = this.utils.decryptString(this.encrypedReferenceId);
    this.httpUtils.fetchV1ApplicationData(applicationIdV1, referenceIdV1).then(serverResponse => {
      if(serverResponse.responseCode === this.constants.STATUS_SUCCESS){
        this.loaderService.stopLoader();
        this.generalDetails = serverResponse.generalDetails; 
        this.feeDetails = serverResponse.feeDetails;
        this.bioDetails = serverResponse.bioDetails;
        this.travelDetails = serverResponse.travelDetails;
        this.contactDetails = serverResponse.contactDetails;

        if(serverResponse.documentsDetails !== null){
          this.applicationDocuments = serverResponse.documentsDetails;

          for(let objectKey of Object.keys(this.applicationDocuments)){
            this.applicationDocumentsArray.push({id: objectKey, fileBase64Data: this.applicationDocuments[objectKey][1], fileType: this.applicationDocuments[objectKey][2], label: objectKey});
          }
        }

        this.paymentDetails = serverResponse.paymentDetails;
        this.isPaid = this.paymentDetails !== null;
        this.barCodeValue = this.barCodeValue = this.constants.VISA_TYPE + '-' + this.bioDetails.applicationIdV1;
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  backToPage() {
    window.scrollTo(0,0);
    
    if(this.isSearchFromHome === this.constants.TRUE) {
      this.gui.openHomePage();
      return;
    }

    this.gui.openDashboardPage();
  }

  printApplication(): void {
    window.print();
  }

  printReceipt(): void {
    const applicationId = this.bioDetails.applicationIdV1;
    const referenceId = this.bioDetails.referenceIdV1;
    const appRefId = applicationId + '|' + referenceId;
    
    this.simpleModalService.addModal(PaymentReceiptModalComponent, {
      applicantId: appRefId,
      isV1Application: this.constants.TRUE
    }, {
      closeOnClickOutside: false
    });
  }

  openFileViewModal(fileBase64Data: string, fileType: string){
    this.simpleModalService.addModal(FileViewModalComponent, {fileBase64Data: fileBase64Data, fileType: fileType}, {autoFocus: true}).subscribe((imageBase64Data: string)=> {

    });
  }

}
